<template>
  <div class="fullHeight">
    <mu-flexbox justify="center" v-if="showFlashMessage">
      <mu-flexbox-item>
        <mu-row>
          <mu-col desktop="30" tablet="25"></mu-col>
          <mu-col desktop="40" tablet="50" class="animated fadeInDown">
            <MessageBox :message-type="flashMessageType" :message="flashMessageBody"
                        :title="flashMessageTitle"></MessageBox>
          </mu-col>
          <mu-col desktop="30" tablet="25"></mu-col>
        </mu-row>
        <mu-row>
        </mu-row>
      </mu-flexbox-item>
    </mu-flexbox>

    <div class="logo">
      <img src="../../../static/logos/lcp-logo.svg" width="312" alt="">
    </div>

    <mu-flexbox align="center" justify="center" v-bind:class="{'fullHeight' : !showFlashMessage}">
      <mu-flexbox-item>
        <mu-row>
          <mu-col desktop="30" tablet="25"></mu-col>
          <mu-col desktop="40" tablet="50" class="animated fadeInDown">
            <mu-card class="formWrap">
              <mu-card-header :title="title" titleClass="blueTitle largeTitle formTitle"></mu-card-header>
              <mu-card-text>
                <form name="login">
                  <mu-text-field
                    id="emailTxt"
                    name="email"
                    v-validate="'required|email'"
                    data-vv-name="email"
                    data-vv-value-path="inputValue"
                    :data-vv-as="$t('message.accountPreferencesEmail')"
                    data-vv-validate-on="none"
                    :errorText="errors.first('email')"
                    :label="$t('message.accountPreferencesEmail')"
                    type="email"
                    v-model="email"
                    :hintText="$t('message.accountPreferencesEmail')"
                    fullWidth
                  ></mu-text-field>
                  <div class="field">
                    <mu-text-field
                      id="passwordTxt"
                      :type="passwordVisible === true ? 'text':'password'"
                      v-validate
                      :data-vv-rules="'required'"
                      data-vv-name="password"
                      data-vv-value-path="inputValue"
                      :data-vv-as="$t('message.accountPreferencesPassword')"
                      :label="$t('message.accountPreferencesPassword')"
                      v-model="password"
                      :errorText="errors.first('password')"
                      :hintText="$t('message.accountPreferencesPassword')"
                      fullWidth>
                    </mu-text-field>
                    <mu-icon-button
                      class="right-icon"
                      @click.native="passwordVisible = !passwordVisible"
                      :icon="!passwordVisible ? 'visibility': 'visibility_off'"
                    ></mu-icon-button>
                  </div>
                  <div class="field" style="overflow: hidden;">
                    <VueRecaptcha
                      :sitekey="captchaSiteKey"
                      :loadRecaptchaScript="false"
                      ref="recaptcha"
                      @verify="onCaptchaVerified"
                      @expired="onCaptchaExpired"></VueRecaptcha>
                  </div>
                  <mu-row>
                    <mu-col>
                      <mu-checkbox v-model="remember_me" :label="$t('message.loginRememberMe')"></mu-checkbox>
                    </mu-col>
                    <mu-col>
                      <router-link to="/forgot-password">{{$t('message.loginForgotPassword')}}</router-link>
                    </mu-col>
                  </mu-row>
                  <mu-raised-button @click.native="submitForm" type="button" :disabled="isLoggingIn || !captchaFilled"
                                    :label="isLoggingIn ? $t('message.loggingInText'): $t('message.logInText')"
                                    class="buttonPrimary"
                                    secondary
                                    fullWidth></mu-raised-button>
                  <mu-flexbox>
                    <div class="optionSpacer">
                      <span class="text">or</span>
                      <span class="line"></span>
                    </div>
                  </mu-flexbox>
                  <mu-flexbox orient="vertical">
                    <mu-flexbox-item v-for="(provider, index) in providers" :key="`provider-${index}`">
                      <mu-raised-button v-on:click="connectAccount(provider.connectUrl)"
                                        type="button"
                                        full-width
                                        :label="provider.buttonText && provider.buttonText.length ? provider.title.toString().replace(/^/, 'Sign in with '): ''"
                                        class="loginButton" v-bind:style="{backgroundColor:provider.brandColour, backgroundImage: provider.buttonText ? '' : `url(${provider.image})`}"
                                        v-bind:class="{darkTextButton : provider.brandColour === '#ffffff', buttonImageOnly : !provider.buttonText || !provider.buttonText.length} "
                                        v-bind:disabled="isLoading">
                        <img style="cursor: pointer" v-bind:src="provider.image">
                      </mu-raised-button>
                    </mu-flexbox-item>
                  </mu-flexbox>
                  <mu-row class="noAccount">
                    <mu-col>
                      {{$t('message.loginNoAccountYet')}}
                    </mu-col>
                    <mu-col>
                      <div v-if="offerCode">
                        <router-link :to="`/register?oc=${offerCode}`">{{$t('message.loginSignUp')}}</router-link>
                      </div>
                      <div v-else>
                        <router-link to="/register">{{$t('message.loginSignUp')}}</router-link>
                      </div>
                    </mu-col>
                  </mu-row>
                  <alert type="danger" icon="error" style="margin-top: 16px; margin-bottom: 0" v-if="hasError">
                    <div slot="content">
                      {{errorMessage || $t('message.loginErrorIncorrectCredentials')}}
                    </div>
                  </alert>
                </form>
              </mu-card-text>
            </mu-card>
          </mu-col>
          <mu-col desktop="30" tablet="25"></mu-col>
        </mu-row>
      </mu-flexbox-item>
    </mu-flexbox>
  </div>
</template>
<script>
  import LoginApi from '../../api/Login'
  import HCPMIxin from '../../mixins/HCPMixin'
  import FlashMessageMixin from '../../mixins/FlashMessageMixin'
  import SocialLoginMixin from '../../mixins/SocialLoginMixin'
  import AuthenticationManager from '../../helpers/AuthenticationManager'
  import UserManager from '../../helpers/UserManager'
  import LessonApi from '../../api/Lessons'
  import MessageBox from "../../components/FlashMessage/MessageBox";
  import EventBus from '../../helpers/EventBus'
  import {Observable} from 'rxjs/Rx'
  import axios from 'axios'
  import Alert from "../../components/Alert/Alert";
  import LifeStyleApi from '../../api/LifeStyle';
  import _ from "lodash";
  const randomString = require('randomstring');
  import VueRecaptcha  from 'vue-recaptcha';
  import Configuration from '../../config'

  export default {
    mixins: [
      HCPMIxin,
      FlashMessageMixin,
      SocialLoginMixin
    ],
    components: {Alert, MessageBox, VueRecaptcha},
    data() {
      return {
        offerCode: null,
        email: '',
        password: '',
        remember_me: true,
        isLoggingIn: false,
        hasError: false,
        errorMessage: '',
        passwordVisible: false,
        captcha: '',
        captchaFilled: false,
        captchaSiteKey: Configuration.captchaSiteKey
      }
    },
    mounted() {
      let self = this;
      let voucher = self.$route.query.voucher;
      if (voucher) {
        self.setCookie('voucher', voucher, 7);
      }

      if (_.has(this.$route.query, 'oc')) {
        this.offerCode = this.$route.query.oc
      }

      if (AuthenticationManager.hasToken()) {
        self.$router.push({
          name: 'Dashboard'
        })
      } else {
        AuthenticationManager.clearSession();

        if (_.has(axios.defaults.headers.common, 'Authorization')) {
          delete axios.defaults.headers.common['Authorization'];
        }
      }


      if (self.$route.query.emailUpdated) {
        self.email = self.$route.query.email;
        self.$alert({
          title: "Successfully updated your email address",
          text: "You can now login with " + self.email,
          type: "success",
          showCancelButton: false,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
        })
      } else if (self.$route.query.tokenInvalid) {
        self.$alert({
          title: "Token Invalid",
          text: "Token is invalid",
          type: "warning",
          showCancelButton: false,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
        })
      }
      self.$gtag.pageview('/login');
    },
    computed: {
      title: function () {
        if (this.offerCode !== null) {
          return `Log in to get 30% off`;
        }

        return this.$t('message.logInText');
      }
    },
    methods: {
      setCookie(name, value, days) {
        var expires = "";
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
      },
      submitForm() {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid === true) {
              self.isLoggingIn = true;
              LoginApi.Authenticate(self.email, self.password, self.remember_me, self.captcha, self.offerCode)
                .then(function (response) {
                  const token = AuthenticationManager.setAccessTokenExpiryTime(response.data);
                  AuthenticationManager.setToken(token);
                  LessonApi.getLessonsList().then(function (response) {
                    self.$store.commit('setLessons', response.data)
                  });

                  UserManager.getUserAndStore(self);

                  if (_.includes(AuthenticationManager.parseJwt().scope, "standard_tasks")) {
                    if (self.isHcpView) {
                      self.$router.push({
                        name: 'HcpGettingStarted'
                      })
                    } else {
                      if (self.$route.query.redirect) {
                        self.$router.push({
                          path: self.$route.query.redirect
                        })
                      } else {
                        self.$router.push({
                          name: 'Dashboard'
                        })
                      }
                    }
                    self.$gtag.event('LoggedIn',{
                      'event_category': 'Authentication',
                      'event_label': 'Logged in',
                      'value': 1
                    });
                  } else if (_.includes(AuthenticationManager.parseJwt().scope, 'unsubscribed_tasks')) {
                    self.$router.push({
                      path: '/subscribe'
                    });
                  }
                })
                .catch(function (error) {
                  if (!_.has(error, 'response')) {
                    self.isLoggingIn = false;
                    return;
                  }

                  self.isLoggingIn = false;
                  self.onCaptchaExpired();
                  if (error.response.status === 401 || error.response.status === 500 || error.response.status === 400) {
                    self.hasError = true;
                    self.errorMessage = error.response.data.message;
                    self.$gtag.event( 'LoginFailed',{
                      'event_category': 'Authentication',
                      'event_label': 'Login failed',
                      'value': 1
                    })
                  }
                  self.countdownError()
                });
            }
          });
      },
      onCaptchaVerified: function (recaptchaToken) {
          this.captcha = recaptchaToken;
          this.captchaFilled = true
      },
      onCaptchaExpired: function () {
        this.$refs.recaptcha.reset();
        this.captcha = '';
        this.captchaFilled = false
      },
      countdownError: function () {
        setTimeout(()=>{this.hasError = false}, 7000)
      }
    }
  }
</script>
<style>
  div#login {
    background-image: url('../../../static/pw/hero-image.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-position-y: -400px;
  }
  .formTitle  {
    font-weight: 500;
    font-size: 1.75rem!important;
  }

  #login .mu-text-field.has-label .mu-text-field-label {
    top: 0;
  }

  #login .formWrap .mu-raised-button-label {
    font-size: 1.125rem;
  }
</style>
<style scoped lang="less">
  .buttonPrimary {
    background: #00aa00!important;
    height: 3.5rem;
    border-radius: 4px;
    margin-top: 1.5rem;
  }
  .formWrap {
    border-radius: 8px;
  }

  .logo {
    margin: 75px 0 25px;
    @media screen and (max-width: 713px) {
      margin-top: 100px;
    }

    img {
      display: block;
      margin: 0 auto;
    }
  }

  .field {
    position: relative;
  }

  .field .right-icon {
    position: absolute;
    top: 20px;
    right: 0;
  }

  .noAccount {
    font-size: 16px;
    margin: 1.5rem 0;
    color: #9B9B9B;
  }

  a {
    color: #0179d5 !important;
    text-decoration: underline !important;
    font-weight: bold;
  }

  .fullHeight {
    height: 100%;
    min-height: 100%;
    max-height: 100%;
  }

  .loginButton {
    border: none;
    height: 3.5rem;
    border-radius: 4px;
    color: #fff;
    img {
      height: 40px;
      width: 40px;
    }
    &.darkTextButton {
      color: #898989;
    }
    &.buttonImageOnly {
      background-size: 60%;
      background-position: center;
      background-repeat: no-repeat;
      img {
        visibility: hidden;
      }
    }
  }

  .nhsButton:hover {
    filter: brightness(0.90);
  }
  .optionSpacer {
    display: flex;
    text-transform: uppercase;
    justify-content: center;
    align-content: center;
    width: 100%;
    position: relative;
    margin: 1.5rem 0;

    .text {
      background: #fff;
      z-index: 1;
      padding: 0 10px;
    }

    .line {
      position: absolute;
      top: 50%;
      border-top: 1px solid #707070;
      width: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// Login.vue?3ae6af9c